import { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import config from "../config";

const NAV_ACTION_DEFAULTS = {
  monitorAllVehicles: {
    path: "/vehicle/TrackAllVehicle",
  },
  monitorAllStops: {
    path: "/stop/all/map",
  },
};

export function useNavActionHandlers() {
  const navigate = useNavigate();
  const [vehicleData, setVehicleData] = useState([]);
  const [stopsData, setStopsData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [vehicleResponse, stopsResponse] = await Promise.all([
          axios.get(`${config.baseURL}/vehicle/organization`, { withCredentials: true }),
          axios.get(`${config.baseURL}/stop/organization`, { withCredentials: true }),
        ]);

        if (Array.isArray(vehicleResponse.data)) {
          setVehicleData(vehicleResponse.data);
        }

        if (Array.isArray(stopsResponse.data)) {
          setStopsData(stopsResponse.data);
        }
      } catch (error) {
        console.error("Error fetching nav monitor data:", error);
      }
    };

    fetchData();
  }, []);

  const monitorAllVehicles = useCallback(() => {
    navigate("/vehicle/TrackAllVehicle", {
      state: { allVehicleData: vehicleData },
    });
  }, [navigate, vehicleData]);

  const monitorAllStops = useCallback(() => {
    navigate("/stop/all/map", {
      state: { allStopsData: stopsData },
    });
  }, [navigate, stopsData]);

  const handlersByKey = {
    monitorAllVehicles,
    monitorAllStops,
  };

  const resolveAction = useCallback(
    (actionKey) => {
      const defaults = NAV_ACTION_DEFAULTS[actionKey];
      const onClick = handlersByKey[actionKey];
      if (!defaults || !onClick) return null;
      return {
        path: defaults.path,
        onClick,
      };
    },
    [monitorAllVehicles, monitorAllStops],
  );

  return { resolveAction };
}
